import { h } from 'preact'
import { IMatchResult } from '../../lib/model'
import styles from './MatchResult.module.css'

interface Props {
  result: IMatchResult
}

export function MatchResult(props: Props) {
  return (
    <div class={styles['dh-fotball-banner__match-result']}>
      <div>{props.result.homeScore}</div>
      <div>-</div>
      <div>{props.result.awayScore}</div>
    </div>
  )
}
